/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { ProgressBar } from "../..";
import { Group, Section } from "./common";
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'card';

/**
 * This is the component description.
 */
const Card = ({
  id,
  className: userClassName,
  style,
  children,
  progress,
  progressBarColor
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: style
}, progress && /*#__PURE__*/React.createElement(ProgressBar, {
  attached: true,
  color: progressBarColor,
  progress: progress,
  height: ".5em"
}), children);
Card.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The progress bar percentage
  */
  progress: PropTypes.number,
  /**
   * The progress bar color
   */
  progressBarColor: PropTypes.string
};
Card.defaultProps = {
  progressBarColor: 'main'
};
Card.Section = Section;
Card.Group = Group;
export default Card;